<template>
  <v-tabs-items v-model="currentTab" style="height:100%;">
    <v-tab-item eager v-for="tab in tabs" :key="tab">
      <div class="presets-wrapper">
        <div
          class="frontend-main-body section-builder-draggable section-builder-presets"
          :class="`page-${slug}`"
        >
          <div style="overflow:hidden;">
            <v-row>
              <v-col cols="6">
                <draggable
                  v-model="oddPresets"
                  v-bind="draggableOptions"
                  @end="clearGhostSections"
                  :class="[
                    `text-color-${templateSettings.design['text-color']}`
                  ]"
                >
                  <div
                    v-for="(preset, index) in oddPresets"
                    :key="index"
                    class="section-wrapper"
                    :class="sectionClasses(preset)"
                    :id="`section-${index}`"
                    @dblclick="addSection(preset)"
                  >
                    <!-- <div class="section-details">
                      <v-container fill-height justify-center>
                        <h2 class="ma-0 pa-0">{{ preset.name }}</h2>
                      </v-container>
                    </div> -->
                    <component
                      :is="preset.type"
                      :section="preset"
                      :templateSettings="templateSettings"
                    ></component>
                  </div>
                </draggable>
              </v-col>

              <v-col cols="6">
                <draggable
                  v-model="evenPresets"
                  v-bind="draggableOptions"
                  @end="clearGhostSections"
                  :class="[
                    `text-color-${templateSettings.design['text-color']}`
                  ]"
                >
                  <div
                    v-for="(preset, index) in evenPresets"
                    :key="index"
                    class="section-wrapper"
                    :class="sectionClasses(preset)"
                    :id="`section-${index}`"
                    @dblclick="addSection(preset)"
                  >
                    <!-- <div class="section-details">
                      <v-container fill-height justify-center>
                        <h2 class="ma-0 pa-0">{{ preset.name }}</h2>
                      </v-container>
                    </div> -->

                    <component
                      :is="preset.type"
                      :section="preset"
                      :templateSettings="templateSettings"
                    ></component>
                  </div>
                </draggable>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </v-tab-item>
  </v-tabs-items>
</template>

<script>
import SectionComponents from '@/components/sections/types'
import { activeTemplate } from '@/graphql/template.gql'
import { pageBySlug, buildPageSections } from '@/graphql/page.gql'
import { mapActions } from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: 'SectionBuilderPresets',
  props: {
    currentTab: {
      type: Number
    }
  },
  components: {
    draggable,
    ...SectionComponents
  },
  data: () => ({
    tabs: [],
    presetsByTab: {
      header: [],
      content: [],
      'article list': [],
      'call to action': [],
      gallery: [],
      footer: [],
      maps: [],
      html: []
    }
  }),
  computed: {
    oddPresets() {
      if (
        !this.presetsByTab[this.tabs[this.currentTab]] ||
        !this.presetsByTab[this.tabs[this.currentTab]].length
      )
        return []

      return this.presetsByTab[this.tabs[this.currentTab]].filter(
        (value, index) => !(index % 2)
      )
    },
    evenPresets() {
      if (
        !this.presetsByTab[this.tabs[this.currentTab]] ||
        !this.presetsByTab[this.tabs[this.currentTab]].length
      )
        return []

      return this.presetsByTab[this.tabs[this.currentTab]].filter(
        (value, index) => index % 2
      )
    },
    slug() {
      return (
        this.$route.params.page ||
        (this.activeTemplate
          ? this.activeTemplate.pages.filter(page => page.home)[0].slug
          : '')
      )
    },
    templateSettings() {
      let templateSettings = {
        content: {},
        design: {},
        layout: {},
        advanced: {}
      }

      if (this.activeTemplate) {
        templateSettings.content = this.activeTemplate.content
        templateSettings.design = this.activeTemplate.design
        templateSettings.layout = this.activeTemplate.layout
        templateSettings.advanced = this.activeTemplate.advanced
      }

      return templateSettings
    },
    draggableOptions() {
      return {
        sort: false,
        animation: 200,
        group: { name: 'sections', pull: 'clone', put: false },
        setData: function(dataTransfer, dragEl) {
          // Create the clone (with content)
          let dragGhost = dragEl.cloneNode(true)
          // Stylize it
          dragGhost.classList.add('custom-drag-image')
          // dragGhost.style.width = '300%'
          dragGhost.style.zoom = 0.33
          // Place it into the DOM tree
          document.getElementById('ghost-sections').appendChild(dragGhost)
          // Set the new stylized "drag image" of the dragged element
          dataTransfer.setDragImage(dragGhost, 10, 10)
        }
      }
    },
    pageSections() {
      return {
        page_id: this.pageBySlug ? this.pageBySlug.id : null,
        sections: this.pageBySlug.sections.map((section, index) => {
          let sections = {
            id: section.id,
            order: section.order
          }

          if (!section.id) {
            sections = {
              id: null,
              order: index + 1,
              global: section.global,
              type: section.type,
              content: section.content,
              design: section.design,
              layout: section.layout,
              advanced: section.advanced
            }
          }

          return sections
        })
      }
    }
  },
  watch: {
    presetsByTab: {
      deep: true,
      handler() {
        let tabs = Object.keys(this.presetsByTab).filter(
          key => Object.keys(this.presetsByTab[key]).length
        )
        this.$emit('update:tabs', tabs)
        this.tabs = tabs
      }
    }
  },
  apollo: {
    activeTemplate: {
      query: activeTemplate
    },
    pageBySlug: {
      query: pageBySlug,
      skip() {
        return !this.activeTemplate
      },
      variables() {
        return {
          data: {
            slug: this.slug,
            template_id: this.activeTemplate.id
          }
        }
      }
    }
  },
  methods: {
    ...mapActions('editor', ['saveChanges']),
    sectionClasses(section) {
      let classes = section.element_classes || ''

      if (
        section.design['background-color'] == 'var(--primary-color)' ||
        (section.layout['content-box'] == '1' &&
          section.layout['content-box-color'] == 'var(--primary-color)')
      ) {
        classes += ` text-color-${this.templateSettings.design['primary-text-color']}`
      }

      if (
        section.design['background-color'] == 'var(--secondary-color)' ||
        (section.layout['content-box'] == '1' &&
          section.layout['content-box-color'] == 'var(--secondary-color)')
      ) {
        classes += ` text-color-${this.templateSettings.design['secondary-text-color']}`
      }

      return classes
    },
    clearGhostSections() {
      const node = document.getElementById('ghost-sections')

      while (node.firstChild) {
        node.removeChild(node.firstChild)
      }
    },
    fillPresetsByCategory() {
      import('@/components/sections/presets/index.js').then(module => {
        let sectionTypes = Object.keys(SectionComponents)

        module.default.forEach(preset => {
          if (
            !preset.tab ||
            !preset.type ||
            !sectionTypes.includes(preset.type)
          )
            return

          if (!this.presetsByTab[preset.tab]) {
            this.presetsByTab[preset.tab] = []
          }

          let presets = this.presetsByTab[preset.tab].concat(preset)

          this.$set(this.presetsByTab, preset.tab, presets)
        })
      })
    },
    addSection(section) {
      section.id = null

      this.pageBySlug.sections.push(section)

      this.buildPageSections()
    },
    buildPageSections() {
      this.saveChanges({
        mutation: buildPageSections,
        variables: {
          data: this.pageSections
        },
        messages: {
          success: 'Sections successfully updated.'
        },
        refetch: true,
        close: false
      })
    }
  },
  mounted() {
    this.fillPresetsByCategory()
  }
}
</script>

<style>
.presets-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  overflow: hidden;
  width: 100%;
}
.section-details {
  position: absolute;
  z-index: 100;
  background-color: rgba(7, 87, 130, 0.8);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity 0.3s ease 0s;
}
.section-details h2 {
  font-size: 32px;
  color: #fff;
  text-align: center;
}
.section-wrapper:hover .section-details {
  opacity: 1;
}
</style>
